export default "__VITE_ASSET__JsT0lNNw__"